// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2a9pB","rootCenter":"LoadMoreObserver_rootCenter__VH-50","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__10vkP"};